<template>
 <!-- 需要 item overview 传参进来 -->
  <div class="item-card-w">
    <div class="print-tip" v-show="selectedItems.length === 0">Select all/specific items to use print function.</div>
    <div class="print-wrapper" v-show="selectedItems.length > 0">
      <el-button type="primary" plain style="margin-top: 20px;" @click="printLabel">Print Label ({{selectedItems.length}})</el-button>
      <el-button type="primary" plain style="margin-top: 20px;" @click="printInstallerCopy">Print Installer Copy ({{selectedItems.length}}</el-button>
      <el-button type="primary" plain style="margin-top: 20px;" @click="printOfficeCopy">Print Office Copy ({{selectedItems.length}}</el-button>
      <div class="print-option" style="display: block; width: 100%;">
        <el-switch
          v-model="directDownload"
          active-color="#ff4949"
          inactive-color="#13ce66"
          active-text="Direct Download"
          inactive-text="Open in Browser">
        </el-switch>
      </div>
    </div>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :default-sort = "{prop: 'folder', order: 'ascending'}"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
       <el-table-column
      prop="folder"
      label="Folder"
      width="100"
      sortable
      :filters="folders"
      :filter-method="filterFolder"
      filter-placement="bottom-end">
    </el-table-column>
      <el-table-column
        prop="item"
        label="Item"
        sortable
        width="80">
      </el-table-column>
      <el-table-column
        prop="mark"
        label="Mark"
        width="80">
      </el-table-column>
      <el-table-column
        prop="quantity"
        label="Qty."
        width="60">
      </el-table-column>
      <el-table-column
        prop="list"
        label="List"
        width="120">
      </el-table-column>
      <el-table-column
        prop="surcharge"
        label="Surcharge"
        width="120">
      </el-table-column>
      <el-table-column
        prop="factor"
        label="Cost Factor"
        width="120">
      </el-table-column>
      <el-table-column
        prop="discount"
        label="Disc Amount"
        width="120">
      </el-table-column>
      <el-table-column
        prop="cost"
        label="Cost"
        width="120">
      </el-table-column>
      <el-table-column
        prop="extended"
        label="Extended"
        width="120">
      </el-table-column>
      <el-table-column
      fixed="right"
      label="Detail"
      width="120">
      <template slot-scope="scope">
        <el-button
          @click.native.prevent="toItemDetail(scope.row.detail)"
          type="text"
          size="small">
          Detail
        </el-button>
      </template>
    </el-table-column>
    </el-table>
    <div class="sum-price">
      <div>Subtotal: $ {{subtotal.toFixed(2)}}</div>
      <div>Handling Fee: $ {{handlingFee.toFixed(2)}}</div>
      <div>Total: $ {{total.toFixed(2)}}</div>
    </div>
    <!-- <div class="left-w">
      <div class="index">{{item.index >= 10 ? item.index : '0'+item.index}}</div>
      <div class="detail-button" @click="toItemDetail()">Detail</div>
    </div>
    <div class="right-w">
      <div class="mark" v-if="item.name">{{item.name}}</div>
      <div class="priority">
        <div class="hight-width">
          <div class="hw-child">
            <div class="hw-title">W</div>
            <div class="hw-value integer">{{width[0]}}</div>
            <div class="hw-value decimal">{{width[1]}}</div>
          </div>
          <div class="hw-child">
            <div class="hw-title">H</div>
            <div class="hw-value integer">{{height[0]}}</div>
            <div class="hw-value decimal">{{height[1]}}</div>
          </div>
        </div>
        <div class="control" v-if="details.control">{{details.control}}</div>
        <div class="rf" v-if="details.rf">{{details.rf}}</div>
        <div class="price" v-if="userLevel < 3">$ {{details.price}} / $ {{details.ext}}</div>
      </div>

      <div class="detail" v-show="showDetail">
        <div id="mount-type">{{details.mountType}}</div>
        <div id="fabric-type">{{details.fabricType}}</div>
        <div id="fabric-spec">{{details.fabricSpec}}</div>
        <div id="quantity">{{details.quantity}}</div>
        <div id="fascia-cover">{{details.fasciaCover}}</div>
        <div id="casement-depth">{{details.casementDepth}}</div>
        <div id="spec">{{details.spec}}</div>
      </div>
      <div @click="showDetail = !showDetail">
        <div class="show-more-button" :style="showDetail ? 'margin-top: 8px':'margin-top: 4px'">{{showDetail ? 'Hide': 'Show More'}}</div>
        <div class="button-line"></div>
      </div>

    </div> -->
  </div>
</template>

<script>
import exportService from '../export'

export default {
  name: 'ItemCard',
  props: {
    items: Array
  },
  data () {
    return {
      showDetail: false,
      selectedItems: [],
      directDownload: false
    }
  },
  computed: {
    tableData: function () {
      let tableData = []
      for (let item of this.items) {
        let row = {
          folder: item.folderName,
          item: item.index,
          mark: item.name,
          quantity: this.fetchValue('quantity', item),
          list: item.priceInfo.list ? parseFloat(item.priceInfo.list).toFixed(2) : '0.00',
          surcharge: item.priceInfo.surcharge ? parseFloat(item.priceInfo.surcharge).toFixed(2) : '0.00',
          factor: item.priceInfo.costFactor ? parseFloat(item.priceInfo.costFactor).toFixed(2) : '1',
          discount: item.priceInfo.discount ? parseFloat(item.priceInfo.discount).toFixed(2) : '0.00',
          cost: this.calcCost(item) || 0.00,
          extended: this.calcExtended(item) || 0.00,
          detail: item
        }
        tableData.push(row)
      }
      return tableData
    },
    folders: function () {
      let folderNames = []
      for (let item of this.items) {
        let folderName = item.folderName
        if (folderNames.findIndex(folder => folder.value === folderName) === -1) {
          folderNames.push({
            value: folderName,
            text: folderName
          })
        }
      }
      return folderNames
    },
    userLevel: function () {
      let currentUserInfo = this.$store.getters.currentUserInfo
      return currentUserInfo || currentUserInfo.userLevel || 4
    },
    subtotal: function () {
      let subTotal = 0
      for (let item of this.selectedItems) {
        subTotal += parseFloat(item.extended)
      }
      return subTotal
    },
    handlingFee: function () {
      let fee = parseFloat(this.$store.getters.currentProject.handlingFee)
      return isNaN(fee) ? 0 : fee
    },
    total: function () {
      return this.subtotal + this.handlingFee
    }
  },
  methods: {
    filterFolder: function (value, row) {
      return row.folder === value
    },
    calcCost: function (item) {
      let list = parseFloat(item.priceInfo.list || '0')
      let surcharge = parseFloat(item.priceInfo.surcharge || '0')
      let costFactor = parseFloat(item.priceInfo.costFactor || '1')
      let discount = parseFloat(item.priceInfo.discount || '0')
      let cost = (list + surcharge) * costFactor - discount
      return cost.toFixed(2)
    },
    calcExtended: function (item) {
      let list = parseFloat(item.priceInfo.list || '0')
      let surcharge = parseFloat(item.priceInfo.surcharge || '0')
      let costFactor = parseFloat(item.priceInfo.costFactor || '1')
      let discount = parseFloat(item.priceInfo.discount || '0')
      let cost = (list + surcharge) * costFactor - discount
      let extended = cost * parseInt(this.fetchValue('quantity', item))
      return extended.toFixed(2)
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.selectedItems = val
    },
    toItemDetail: function (item) {
      this.$emit('to-item', item)
      window.scrollTo(0, 0)
    },
    fetchValue: function (fetchTarget, item) {
      let question
      switch (fetchTarget) {
        case 'control':
          question = item.questions.find(q => {
            return q.id === 'radio_control'
          })
          if (!question) {
            return 'No Control'
          }
          return question.value
        case 'rf':
          return item.rf || ''
        case 'mount-type':
          question = item.questions.find(q => {
            return q.id === 'radio_mountType'
          })
          if (!question) {
            return ''
          }
          return question.value
        case 'fabric-type':
          question = item.questions.find(q => {
            return q.id === 'radio_fabricType'
          })
          if (!question) {
            return ''
          }
          return question.value
        case 'fabric-spec':
          question = item.questions.find(q => {
            return q.id === 'input_fabric'
          })
          if (!question) {
            return ''
          }
          return question.value
        case 'spec':
          question = item.questions.find(q => {
            return q.id === 'input_specialNote'
          })
          if (!question) {
            return ''
          }
          return question.value
        case 'quantity':
          question = item.questions.find(q => {
            return q.id === 'input_qty'
          })
          if (!question) {
            return ''
          }
          return parseInt(question.value)
        case 'fascia-cover':
          question = item.questions.find(q => {
            return q.id === 'ckwop_fasciaCover'
          })
          if (question) {
            return question.value[0] === 'Yes' ? question.value[1] : 'No Fascia Cover'
          } else {
            return ''
          }
        case 'casement-depth':
          question = item.questions.find(q => {
            return q.id === 'input_casementDepth'
          })
          if (!question) {
            return ''
          }
          return question.value[0] ? 'Casement Depth: ' + question.value[0] : ''
      }
    },
    printLabel: async function () {
      this.exporting = true
      let exportResult = await exportService.printLabel(
        this.$store.getters.currentProject,
        this.$store.getters.currentUserInfo,
        this.selectedItems,
        this.directDownload
      )
      this.exporting = false
      if (!exportResult.success) {
        console.log(exportResult.error)
        this.$alert(
          'Sorry, the exporting service is currently unavailable, please try again. If refresh not work, please contact us for help.',
          'Error', {
            confirmButtonText: 'Dismiss',
            callback: action => {
              this.$refs.multipleTable.clearSelection()
            }
          })
      }
    },
    printOfficeCopy: async function () {
      this.exporting = true
      let exportResult = await exportService.printOfficeCopy(
        this.$store.getters.currentProject,
        this.$store.getters.currentUserInfo,
        this.selectedItems,
        this.directDownload
      )
      this.exporting = false
      if (!exportResult.success) {
        console.log(exportResult.error)
        this.$alert(
          'Sorry, the exporting service is currently unavailable, please try again. If refresh not work, please contact us for help.',
          'Error', {
            confirmButtonText: 'Dismiss',
            callback: action => {
              this.$refs.multipleTable.clearSelection()
            }
          })
      }
    },
    printInstallerCopy: async function () {
      console.log('function called')
      this.exporting = true
      let exportResult = await exportService.printInstallerCopy(
        this.$store.getters.currentProject,
        this.$store.getters.currentUserInfo,
        this.selectedItems,
        this.directDownload
      )
      this.exporting = false
      if (!exportResult.success) {
        console.log(exportResult.error)
        this.$alert(
          'Sorry, the exporting service is currently unavailable, please try again. If refresh not work, please contact us for help.',
          'Error', {
            confirmButtonText: 'Dismiss',
            callback: action => {
              this.$refs.multipleTable.clearSelection()
            }
          })
      }
    }
  }
}
</script>

<style>
.print-wrapper {
  display: flex;
  flex-direction: row;
  /* justify-content: flex-end; */
  align-items: flex-end;
  margin-top: 32px;
  margin-bottom: 32px;
}

.item-card-w {
  padding: 20px;
  box-sizing: border-box;
  /* display: flex;
  align-items: center; */
}

.left-w {
  width: 96px;
  display: inline-block;
  text-align: center;
}

.right-w {
  width: calc(99.9% - 96px);
  display: inline-block;
  margin-left: 20px;
}

.index {
  font-size: 32px;
  width: 100%;
  text-align: center;
  color: #1e88e5;
  font-weight: bold;
}

.hight-width {
  display: inline-block;
}

.hw {
  width: 100%;
}

.priority {
  line-height: 48px;
  display: inline-block;
}

.hw-child {
  display: inline-block;
  box-sizing: border-box;
  padding-right: 20px;
}

.control {
  display: inline-block;
  box-sizing: border-box;
  padding-right: 20px;
}

.rf {
  display: inline-block;
  box-sizing: border-box;
  padding-right: 20px;
}

.mark {
  font-weight: bold;
  display: inline-block;
  margin-right: 24px;
  color: #333333;
}

.show-more-button {
  font-size: 14px;
  line-height: 21px;
  box-sizing: border-box;
  padding: 6px 0;
  width: 100px;
  text-align: center;
  cursor: pointer;
}

.detail-button {
  cursor: pointer;
}

.button-line {
  height: 1px;
  width: 60px;
  margin-left: 20px;
  background-color: #e0e0e0;
}

.hw-title {
  display: inline;
  color: #666666;
  font-size: 14px;
  margin-right: 8px;
}

.hw-value {
  display: inline;
  color: #1e88e5;
  text-align: center;
  font-weight: 700;
}

.integer {
  font-size: 24px;
  margin-right: 8px;
}
.decimal {
  font-size: 16px;
  color: #333333;
}

.detail {
  line-height: 24px;
}

@media screen and (max-width: 991px) {
  .item-card-w {
    padding: 16px 12px;
    box-sizing: border-box;
    display: block;
  }

  .left-w {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    line-height: 36px;
  }

  .index {
    font-size: 20px;
    width: 100%;
    text-align: left;
    color: #1e88e5;
  }

  .detail-button {
    cursor: pointer;
    font-size: 12px;
  }

  .right-w {
    width: 100%;
    display: block;
    margin-left: 0;
  }

  .priority {
    margin-top: 6px;
    line-height: 25px;
    display: inline-block;
    font-size: 15px;
  }

  .mark {
    font-size: 16px;
    line-height: 25px;
  }

  .detail {
    font-size: 16px;
    line-height: 24px;
  }

  .show-more-button {
    font-size: 12px;
  }

  .integer {
    font-size: 20px;
    margin-right: 8px;
  }

  .decimal {
    font-size: 16px;
    color: #333333;
  }
}
</style>
